import { CleaningTypeComponent } from '@components/pages/management/infrastructure/cleaning-type/cleaning-type.component';
import { FlatTypeComponent } from '@components/pages/management/infrastructure/flat-type/flat-type.component';
import { FloorComponent } from '@components/pages/management/infrastructure/floor/floor.component';
import { MetersComponent } from '@components/pages/management/infrastructure/meters/meters.component';
import { TaxComponent } from '@components/pages/management/infrastructure/tax/tax.component';
import { UnitComponent } from '@components/pages/management/infrastructure/unit/unit.component';
// Management
import { UsersComponent } from '@components/pages/management/users/users.component';
import { Notfound } from '@components/pages/notfound/notfound';
import { ArrivalDepartureComponent } from '@components/pages/service-pages/arrival-departure/arrival-departure.component';
import { ParkingRequestContainerComponent } from '@components/pages/service-pages/parking/components/parking-request-container/parking-request-container.component';
// Services
import { ParkingComponent } from '@components/pages/service-pages/parking/parking.component';
import { BookingDetailComponent } from '@components/pages/short-term-rental/booking-detail/booking-detail.component';
import { BookingOverviewComponent } from '@components/pages/short-term-rental/booking-overview/booking-overview.component';
import { BookingsComponent } from '@components/pages/short-term-rental/bookings/bookings.component';
import { CheckinsComponent } from '@components/pages/short-term-rental/checkins/checkins.component';
import { InvoicingComponent } from '@components/pages/short-term-rental/invoicing/invoicing.component';
// Short Term Rental
import { OverviewStComponent } from '@components/pages/short-term-rental/overview-st/overview-st.component';
import { PresenceOverviewComponent } from '@components/pages/short-term-rental/presence-overview/presence-overview.component';
import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { AuthGuard } from './app/services/guard/auth.guard';
import { RoleGuard } from './app/services/guard/role.guard';
import { StayOrdersGuard } from './app/services/guard/stay-orders.guard';
import { SuperAdminGuard } from './app/services/guard/super-admin.guard';

export const appRoutes: Routes = [
  {
    path: '', // For USER'S NEW PAGES, using AppLayout
    component: AppLayout,
    canActivate: [AuthGuard],
    children: [
      { path: 'overview-st', component: OverviewStComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['short-term-overview'] } },
      { path: 'booking-overview', component: BookingOverviewComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['booking'] } },
      { path: 'presence', component: PresenceOverviewComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['booking'] } },
      { path: 'bookings', component: BookingsComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['booking'] } },
      { path: 'bookings/:id', component: BookingDetailComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['booking'] } },
      { path: 'checkins', component: CheckinsComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['checkin'] } },
      { 
        path: 'checkins/:id', 
        loadComponent: () => import('@components/pages/short-term-rental/checkins/components/checkin-detail/checkin-detail.component').then(c => c.CheckinDetailComponent),
        canActivate: [RoleGuard], 
        data: { requiredPermissions: ['checkin'] } 
      },
      {
        path: 'invoices',
        children: [
          { path: '', component: InvoicingComponent },
          { path: ':id', loadComponent: () => import('@components/pages/short-term-rental/invoicing/components/invoice-detail/invoice-detail.component').then(c => c.InvoiceDetailComponent) },
          { path: ':id/preview', loadComponent: () => import('@components/pages/short-term-rental/invoicing/components/invoice-preview/invoice-preview.component').then(c => c.InvoicePreviewComponent) }
        ],
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['invoice'] }
      },
      {
        path: 'parking',
        children: [
          { path: '', component: ParkingComponent },
          { path: 'request/new', component: ParkingRequestContainerComponent },
          { path: 'request/:id', component: ParkingRequestContainerComponent }
        ],
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['parking'] }
      },
      {
        path: 'cleaning',
        loadComponent: () => import('@components/pages/service-pages/cleaning/cleaning.component').then(c => c.CleaningComponent),
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['cleaning'] }
      },
      {
        path: 'schedule-planner',
        loadComponent: () => import('@components/pages/service-pages/schedule-planner/schedule-planner.component').then(c => c.SchedulePlannerComponent),
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['cleaning-schedule'] }
      },
      {
        // Staff (cleaner) view — inside AppLayout so it gets the menu/frame on desktop;
        // view-only permission so cleaning staff (not just managers) can reach it.
        path: 'schedule-planner/staff',
        loadComponent: () => import('@components/pages/service-pages/schedule-planner/staff/schedule-planner-staff.component').then(c => c.SchedulePlannerStaffComponent),
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['cleaning-schedule-view'] }
      },
      {
        // Naplózás: a sidecar közös aktivitás-naplójának területenkénti nézetei, CSAK SUPERADMIN-nak
        // (szerepkör-, nem jogosultság-alapú kapu). A terület a slugból jön (ACTIVITY_LOG_AREAS).
        path: 'logging/:area',
        loadComponent: () => import('@components/pages/activity-log/activity-log-page.component').then((c) => c.ActivityLogPageComponent),
        canActivate: [SuperAdminGuard]
      },
      // A Beosztás-napló korábbi címe — régi könyvjelzők miatt.
      { path: 'schedule-planner/activity-log', redirectTo: 'logging/schedule-planner' },
      {
        path: 'maintenance',
        loadComponent: () => import('@components/pages/service-pages/cleaning/components/maintenance-overview/maintenance-overview.component').then(c => c.MaintenanceOverviewComponent),
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['cleaning'] } // Using cleaning permission for now
      },
      {
        path: 'cleaning-management',
        loadComponent: () => import('@components/pages/service-pages/cleaning-management/cleaning-management.component').then(c => c.CleaningManagementComponent),
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['cleaning-request'] }
      },
      {
        // Stay reggeli-rendelések: nem permission-, hanem szerepkör-halmaz alapú kapu,
        // ezért saját guard (lásd StayOrdersGuard / AuthenticationService.canAccessStayOrders).
        path: 'stay-orders',
        loadComponent: () => import('@components/pages/service-pages/stay-orders/stay-orders.component').then((c) => c.StayOrdersComponent),
        canActivate: [StayOrdersGuard]
      },
      {
        path: 'arrival-departure',
        component: ArrivalDepartureComponent,
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['arrival-departures'] }
      },
      {
        path: 'issues',
        loadChildren: () => import('@components/pages/service-pages/issues/issues.module').then((m) => m.IssuesModule),
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['issue'] }
      },
      {
        path: 'calendar',
        loadChildren: () => import('@components/pages/service-pages/calendar/calendar.routes').then((m) => m.CALENDAR_ROUTES),
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['calendar'] }
      },
      {
        path: 'coupons',
        loadChildren: () => import('@components/pages/service-pages/coupons/coupon.routes').then((m) => m.COUPON_ROUTES),
        canActivate: [RoleGuard],
        data: { requiredPermissions: ['coupon'] }
      },
      { path: 'users', component: UsersComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['user'] } },
      { path: 'flat-type', component: FlatTypeComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['master-data'] } },
      { path: 'cleaning-type', component: CleaningTypeComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['master-data'] } },
      { path: 'floor', component: FloorComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['master-data'] } },
      { path: 'tax', component: TaxComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['master-data'] } },
      { path: 'unit', component: UnitComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['master-data'] } },
      { path: 'meters', component: MetersComponent, canActivate: [RoleGuard], data: { requiredPermissions: ['meter'] } },
      // Default route handling - redirects to overview-st
      { path: '', redirectTo: 'overview-st', pathMatch: 'full' }
    ]
  },
  // Standalone cleaning detail - no layout wrapper for mobile-first design
  {
    path: 'cleaning/detail/:scheduleId',
    loadComponent: () => import('@components/pages/service-pages/cleaning/components/cleaning-detail/cleaning-detail.component').then(c => c.CleaningDetailComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: { requiredPermissions: ['cleaning'] }
  },
  // Standalone routes remain the same
  { path: 'notfound', component: Notfound },
  { path: 'auth', loadChildren: () => import('@components/pages/auth/auth.routes') },
  { path: '**', redirectTo: '/notfound' } // Catch-all
];
